import { useSessionStore } from '@/stores/sessionStore'

/**
 * Fire-and-forget diagnostic beacon. Sends an `<img>` GET to the backend's
 * `/ht/api/status` so the params land in the server access log.
 *
 * Why an `<img>` and not the axios client: a beacon must survive a wedged
 * transport. The cases we most want telemetry on (a stuck token refresh, a
 * preview that can't reach the BE) are exactly the cases where `apiClient`
 * is itself blocked — routing the beacon through it would lose the signal at
 * the moment we need it. The image request bypasses the interceptor chain.
 *
 * Best-effort only: diagnostics must never affect checkout, so every failure
 * is swallowed.
 */
export function fireBeacon(params: Record<string, string | number | boolean>): void {
  try {
    const base = useSessionStore.getState().backendUrl || ''
    const qs = new URLSearchParams(
      Object.entries(params).reduce((acc, [k, v]) => {
        acc[k] = String(v)
        return acc
      }, {} as Record<string, string>),
    ).toString()
    const img = new Image()
    img.src = `${base}/ht/api/status?${qs}`
  } catch {
    // Diagnostics must never affect checkout.
  }
}
